/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useLabels } from '@/hooks/useLabels';
import { Button, Icon, Text, View } from '@az/starc-ui';
import { Close } from '@az/starc-ui-icons';
import styles from './styles.module.scss';

export type InlineFiltersProps = {
  starFilter: number[];
  setStarFilter: React.Dispatch<React.SetStateAction<number[]>>;
};

const labelMap = {
  activeFilters: 'label_reviews_activeFilters',
  star: 'label_reviews_star',
  stars: 'label_reviews_stars',
  clearAll: 'label_reviews_clearAll',
};

export function InlineFilters({ starFilter, setStarFilter }: InlineFiltersProps) {
  const labels = useLabels(labelMap);
  return (
    <View
      attributes={{
        'data-testid': 'inlineFilters',
      }}
    >
      <Text className={styles.filtersLabel} weight="bold">
        {labels.activeFilters}
      </Text>
      <View className={styles.filterRow}>
        <View>
          <Button
            className={styles.filterButton}
            onClick={() => {
              setStarFilter([]);
            }}
          >
            {labels.clearAll}
          </Button>
        </View>
        {starFilter.map((star) => (
          <View key={star}>
            <Button
              className={styles.filterButton}
              variant="secondary"
              onClick={() => {
                setStarFilter((prevStars) => prevStars.filter((s) => s !== star));
              }}
              endIcon={<Icon svg={Close} size={5} />}
            >
              {`${star} ${star === 1 ? labels.star : labels.stars}`}
            </Button>
          </View>
        ))}
      </View>
    </View>
  );
}
